var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sharer",on:{"click":_vm.shareSocial}},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.icon}}),(_vm.count)?_c('span',[_vm._v(_vm._s(_vm.count)+"\n    ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }